import styled, { keyframes } from 'styled-components';
import { ToastType } from './index';

const slideIn = keyframes`
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
`;

const slideOut = keyframes`
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(100%);
        opacity: 0;
    }
`;

export const StyledToastContainer = styled.div`
    position: fixed;
    top: calc(var(--header-height) + var(--space-6));
    right: var(--space-6);
    z-index: var(--z-tooltip);
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    pointer-events: none;
    
    @media (max-width: 768px) {
        top: calc(var(--header-height) + var(--space-4));
        right: var(--space-4);
        left: var(--space-4);
    }
`;

const getToastColor = (type: ToastType) => {
    switch (type) {
        case 'success':
            return 'var(--status-success)';
        case 'error':
            return 'var(--status-error)';
        case 'warning':
            return 'var(--status-warning)';
        case 'info':
            return 'var(--status-info)';
    }
};

export const StyledToast = styled.div<{ type: ToastType; $isExiting: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: var(--space-3);
    min-width: 320px;
    max-width: 480px;
    padding: var(--space-4);
    background-color: var(--surface-default);
    border: 1px solid var(--border-light);
    border-left: 4px solid ${props => getToastColor(props.type)};
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-xl);
    pointer-events: auto;
    animation: ${props => props.$isExiting ? slideOut : slideIn} 300ms ease-out;
    
    @media (max-width: 768px) {
        min-width: unset;
        max-width: unset;
    }
    
    .toast-content {
        flex: 1;
        min-width: 0;
    }
    
    .toast-message {
        font-size: var(--text-base);
        font-weight: var(--font-semibold);
        color: var(--text-primary);
        margin-bottom: var(--space-1);
    }
    
    .toast-description {
        font-size: var(--text-sm);
        color: var(--text-secondary);
        line-height: var(--leading-relaxed);
    }
    
    .toast-close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        padding: 0;
        background: transparent;
        border: none;
        border-radius: var(--radius-sm);
        color: var(--text-tertiary);
        cursor: pointer;
        transition: all var(--transition-fast);
        flex-shrink: 0;
        
        &:hover {
            background-color: var(--surface-hover);
            color: var(--text-primary);
        }
        
        &:active {
            background-color: var(--surface-active);
        }
    }
`;

export const ToastIcon = styled.div<{ type: ToastType }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: ${props => getToastColor(props.type)};
    font-size: var(--text-xl);
`;
